/**
 * Custom hook for mission data
 */

import { useApi } from './useApi';
import { fetchMissionData } from '@/lib/api/mission';

export function useMissionData() {
  return useApi(fetchMissionData, []);
}
